import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check, Globe } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { LOGO_URL } from "@/components/Navbar";

const OPTIONS = [
  { code: "en", name: "English", hint: "Welcome to D&D Padel" },
  { code: "fr", name: "Français", hint: "Bienvenue chez D&D Padel" },
  { code: "cr", name: "Kreol Morisien", hint: "Bienveni kot D&D Padel" },
];

export default function LanguagePicker() {
  const { lang, setLang, t } = useLanguage();
  const [open, setOpen] = useState(() => !localStorage.getItem("padel-lang-chosen"));

  const confirm = () => {
    localStorage.setItem("padel-lang-chosen", "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-sm [&>button]:hidden" data-testid="language-picker">
        <img src={LOGO_URL} alt="D&D Padel" className="w-16 h-16 rounded-2xl mx-auto mb-1" />
        <DialogTitle className="text-center font-heading text-xl flex items-center justify-center gap-2"><Globe size={18} className="text-coral" /> {t("langpick.title")}</DialogTitle>
        <DialogDescription className="text-center text-xs">{t("langpick.subtitle")}</DialogDescription>
        <div className="space-y-2 mt-2">
          {OPTIONS.map(o => (
            <button key={o.code} onClick={() => setLang(o.code)} data-testid={`langpick-${o.code}`}
              className={`w-full flex items-center justify-between rounded-2xl border px-4 py-3 text-left transition-colors ${lang === o.code ? "border-coral bg-coral/10" : "border-border/50 hover:bg-muted/40"}`}>
              <span>
                <span className="block font-semibold">{o.name}</span>
                <span className="block text-xs text-muted-foreground">{o.hint}</span>
              </span>
              {lang === o.code && <Check size={18} className="text-coral" />}
            </button>
          ))}
        </div>
        <div><Button onClick={confirm} className="w-full rounded-full bg-coral hover:bg-coral-600 text-white h-11 mt-2" data-testid="langpick-continue">{t("langpick.continue")}</Button></div>
      </DialogContent>
    </Dialog>
  );
}
